import { render, staticRenderFns } from "./CourseCenterDetail.vue?vue&type=template&id=5ee06fff&scoped=true"
import script from "./CourseCenterDetail.vue?vue&type=script&lang=js"
export * from "./CourseCenterDetail.vue?vue&type=script&lang=js"
import style0 from "./CourseCenterDetail.vue?vue&type=style&index=0&id=5ee06fff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee06fff",
  null
  
)

export default component.exports